import { makeStyles } from "@mui/styles";
import { AutocompleteMenuPortalContext } from "components/Form/components/Autocomplete/AutocompleteMenuPortalContext";
import { centeredPopoverRootStyle, Popover } from "components/Popover/Popover";
import { PropsWithChildren } from "react";

interface RecordPromptPopoverProps {
    isOpened: boolean;
    rootStyle?: any;
    paperStyle?: any;
}

export const RecordPromptPopover = ({
    isOpened,
    rootStyle = centeredPopoverRootStyle,
    paperStyle,
    children,
}: PropsWithChildren<RecordPromptPopoverProps>) => {
    const useStyles = makeStyles(() => ({
        rootStyle,
        paperStyle,
    }));
    const classes = useStyles();

    return (
        <Popover
            isOpen={isOpened}
            anchorReference="none"
            classes={{ root: classes.rootStyle, paper: classes.paperStyle }}
            rootClassName="recordPrompt__popover"
            contentClassName="recordPrompt__content"
        >
            <AutocompleteMenuPortalContext.Provider value={true}>
                {children}
            </AutocompleteMenuPortalContext.Provider>
        </Popover>
    );
};
